import script from "./TextQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TextQuestion.vue?vue&type=script&setup=true&lang=js"

import "./TextQuestion.vue?vue&type=style&index=0&id=72fa2401&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fa2401"]])

export default __exports__